// extracted by mini-css-extract-plugin
export default {"padlockContainer":"Padlock_padlockContainer__r2mcs","txt":"Padlock_txt__gFsiG","disabled":"Padlock_disabled__60JJZ","iconName":"Padlock_iconName__AK8ht","icon":"Padlock_icon__26CoD"};